const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.TRANSACTIONS)

export const apiTransactions = {
	fetchTransactions: async ({
		search,
		status,
		clientID,
		source,
		dateFrom,
		dateTo,
		paymentMethod,
		type,
		page = 1,
		perPage = 25,
		filters,
	}: {
		search?: string
		status?: ETransactionStatus[]
		clientID?: string
		source?: ETransactionSource[]
		dateFrom?: Date
		dateTo?: Date
		paymentMethod?: ETransactionPaymentMethod[]
		type?: ETransactionType[]
		page?: number
		perPage?: number
		filters?: IApiFilters
	}) => {
		const { data, meta } = await apiCommon<IPaymentTransaction[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(
				{ page, perPage },
				{
					status,
					search,
					client_id: clientID,
					source,
					payment_method: paymentMethod,
					created_from: dateFrom ? dateToFilterFormat(dateFrom) : undefined,
					created_to: dateTo ? dateToFilterFormat(dateTo) : undefined,
					cart_item_type: type,
					...filters,
				},
			),
		})
		return { data: data.map(d => PaymentTransaction(d)), meta }
	},
}
